import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
export default function LendingApplicationsReports() {
    const [lists, setLists] = useState([]);
    const params= useParams();
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDINGAPPLICATIONREPORT + "?status=" + params.status, { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data);
                }
            });
    };
    useEffect(() => {
        GetData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid card pt-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">Report Lending Applications</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="table-responsive table-card">
                                            <table className="table align-middle" id="customerTable">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Company</th>
                                                        <th>Contact Name</th>
                                                        <th>Business Email</th>
                                                        <th>Mobile</th>
                                                        <th>Amount Requested</th>
                                                        <th>Submitted Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all">
                                                    {lists.length > 0 && lists.map((v, index) =>
                                                        <tr key={v.lenderId}>
                                                            <td>{index + 1}</td>
                                                            <td>{v.businessLegalName}</td>
                                                            <td>{v.oFirstName}</td>
                                                            <td>{v.businessEmail}</td>
                                                            <td>{v.businessPhoneNumber}</td>
                                                            <td>USD {v.amountRequested}</td>
                                                            <td>{moment(v.createdDate).format('DD MMM YYYY')}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> {/* .card*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}